const isPro = process.env.NODE_ENV === 'production'
//在非生产环境下，使用严格模式
const strict = process.env.NODE_ENV !== 'production'

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

// 状态
const state = {
    userInfo: null,
    access_token: "",
    refresh_token: "",
    expires_in: '',
    locale: '',
}

// 类似于computed
const getters = {
    userInfo: state => {
        return state.userInfo || LocalStore.get('userInfo')
    },
    access_token: state => {
        return state.access_token || LocalStore.get('access_token')
    },
    refresh_token: state => {
        return state.refresh_token || LocalStore.get('refresh_token')
    },
    expires_in: state => {
        return state.expires_in || LocalStore.get('expires_in')
    },
    locale: state => {
        return state.locale || localStorage.getItem('locale');
    }
}

const mutations = {
    SET_LOCALE: (state, params) => {
        localStorage.setItem('locale', params)
        state.locale = params;
    },
    SET_USER_INFO: (state, params) => {
        LocalStore.set('userInfo', params)
        state.role_identity = params.role_identity;
        state.userInfo = params
    },
    SET_ACCESS_TOKEN: (state, params) => {
        LocalStore.set('access_token', params)
        state.access_token = params
    },
    SET_REFRESH_TOKEN: (state, params) => {
        LocalStore.set('refresh_token', params)
        state.refresh_token = params
    },
    SET_EXPIRES_IN: (state, params) => {
        LocalStore.set('expires_in', params)
        state.expires_in = params
    },
    SET_EXPIRES_IN_STORE_TIME: (state) => {
        state.expires_in_store_time = parseInt(new Date().getTime() / 1000)
        LocalStore.set('expires_in_store_time', state.expires_in_store_time)
    }
}


export default new Vuex.Store({ strict, state, getters, mutations })